module.exports = __webpack_public_path__ + "media/images/beach-1-570bae91.jpg";